import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { getEnvironmentConfig } from '../../utils/environmentConfig';

// Get environment-specific configuration
const envConfig = getEnvironmentConfig();

// MSAL configuration
const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID || '',
    authority: import.meta.env.VITE_AZURE_AD_AUTHORITY || '',
    redirectUri: envConfig.redirectUri,
    postLogoutRedirectUri: envConfig.postLogoutRedirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage', // Changed from localStorage to sessionStorage
    storeAuthStateInCookie: false, // Changed to false to avoid persistent state
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        // Only log errors to console
        if (level === 0) { // Error level
          console.error(`MSAL: ${message}`);
        }
      },
      logLevel: 0, // Error level only
      piiLoggingEnabled: false,
    },
  },
};

// Login request scopes - includes Office 365 access
export const loginRequest = {
  scopes: [
    'User.Read', 
    'Mail.Read', 
    'Files.Read.All',
    'Calendars.Read',
    'Chat.Read',
    'ChannelMessage.Read.All',
    'Team.ReadBasic.All',
    'Channel.ReadBasic.All',
    'openid', 
    'profile'
  ],
};

// Graph API scopes - same as login for simplicity
export const graphRequest = {
  scopes: [
    'User.Read', 
    'Mail.Read', 
    'Files.Read.All',
    'Calendars.Read',
    'Chat.Read',
    'ChannelMessage.Read.All',
    'Team.ReadBasic.All',
    'Channel.ReadBasic.All'
  ],
};

// Function to create a fresh MSAL instance
export const createMsalInstance = () => {
  return new PublicClientApplication(msalConfig);
};

// Create the initial MSAL instance
export let msalInstance = createMsalInstance();

// Function to reset MSAL completely
export const resetMsalInstance = async () => {
  try {
    console.log('Resetting MSAL instance completely...');
    
    // Clear browser storage manually
    localStorage.clear();
    sessionStorage.clear();
    
    // Clear all cookies for this domain
    document.cookie.split(";").forEach((c) => {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    
    // Create a completely new instance
    msalInstance = createMsalInstance();
    
    console.log('MSAL instance reset complete');
    return msalInstance;
  } catch (error) {
    console.error('Error resetting MSAL instance:', error);
    throw error;
  }
};